import { Bones } from '@simplywallst/ui-core';

export const NarrativeSkeletonLoader = () => {
  return (
    <div className="grid grid-rows-[152px_40px_500px_800px] gap-x2 lg:grid-cols-[2fr_1fr] lg:grid-rows-[152px_40px_minmax(800px,1fr)]">
      <Bones borderRadiusLg="x2" />
      <Bones className="lg:col-start-2 lg:row-span-3" borderRadiusLg="x2" />
      <Bones borderRadiusLg="x2" />
      <Bones borderRadiusLg="x2" />
    </div>
  );
};
